import React, { useContext, useState, useEffect } from 'react';
import { AuthContext } from '../context/AuthContext';
import { Link, useNavigate, NavLink } from 'react-router-dom';
import styles from './Profile.module.css';

export default function Profile() {
    const { user, logout } = useContext(AuthContext);
    const [myCourses, setMyCourses] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) return;
        fetch(`${process.env.REACT_APP_API_URL}/api/courses`, {
            credentials: 'include'
        })
            .then(r => r.json())
            .then(setMyCourses)
            .catch(console.error);
    }, [user]);

    const confirmDelete = async () => {
        await fetch(`${process.env.REACT_APP_API_URL}/api/auth/delete`, {
            method: 'DELETE',
            credentials: 'include'
        });
        logout();
        navigate('/');
    };

    if (!user) return <div className={styles.loading}>Cargando perfil…</div>;

    return (
        <div className={styles.container}>
            <h1 className={styles.title}>Mi perfil</h1>

            <div className={styles.profileHeader}>
                {user.picture && (
                    <img src={user.picture} alt="Foto de perfil" className={styles.avatar} />
                )}
                <div className={styles.profileDetails}>
                    {user.name && <p><strong>Nombre:</strong> {user.name}</p>}
                    <p><strong>Email:</strong> {user.email}</p>
                </div>
            </div>

            <nav className={styles.tabs}>
                <NavLink to="/profile/courses" className={({ isActive }) =>
                    `${styles.tab} ${isActive ? styles.active : ''}`}>Mis cursos</NavLink>
            </nav>

            <section className={styles.list}>
                {myCourses.length ? (
                    myCourses.map(c => (
                        <Link to={`/courses/${c.id}`} key={c.id} className={styles.card}>
                            <img src={c.imageUrl} alt={c.title} className={styles.cardImg} />
                            <h3 className={styles.cardTitle}>{c.title}</h3>
                        </Link>
                    ))
                ) : (
                    <p className={styles.noCourses}>No estás suscrito a ningún curso.</p>
                )}
            </section>

            <section className={styles.accountActions}>
                <h3 className={styles.actionsTitle}>Gestión de cuenta</h3>
                <div className={styles.buttons}>
                    <button onClick={logout} className={styles.btnSecondary}>Cerrar Sesión</button>
                    <button onClick={() => setShowModal(true)} className={styles.btnRevoke}>Eliminar Cuenta</button>
                </div>
            </section>
            {showModal && (
                <div className={styles.modalBackdrop}>
                    <div className={styles.modal}>
                        <h2>¿Estás seguro?</h2>
                        <p>Eliminar tu cuenta es una acción irreversible. ¿Deseas continuar?</p>
                        <div className={styles.modalActions}>
                            <button onClick={() => setShowModal(false)} className={styles.btnSecondary}>Cancelar</button>
                            <button onClick={confirmDelete} className={styles.btnRevoke}>Sí, eliminar cuenta</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
